<app-dialog [subtitle]="subtitles.setSubtitle(1183)" [hideIcon]="true"
            data-testid="progress-bar">
    <form-item-text [subtitle]="appAlert.progressBarMessage"></form-item-text>
    <form-action-buttons [justify]="'center'">
        <progress class="app-alert__progress-bar"
                  [value]="appAlert.progressValue"
                  max="100">
        </progress>
    </form-action-buttons>
</app-dialog>
